<template>
  <div class="compressed-content">
    <h3 class="page-question">Have you been told you have metabolic syndrome?</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.hasMetabolicSyndrome">
      <b-form-radio v-model="survey.medicalConditions.hasMetabolicSyndrome" name="metabolic"
                    :value="true">
        Yes
      </b-form-radio>
      <b-form-radio v-model="survey.medicalConditions.hasMetabolicSyndrome" name="metabolic"
                    :value="false">
        No
      </b-form-radio>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required } from "vuelidate/lib/validators";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  export default {
    mixins: [formMixin],

    validations: {
      hasMetabolicSyndrome: {
        required
      }
    },

    computed: {
      ...mapState(["survey"]),

      hasMetabolicSyndrome() { return this.survey.medicalConditions.hasMetabolicSyndrome }
    }
  };
</script>